import { useSearchParams } from 'react-router-dom';
import DisappointingSheet from './DisappointingSheet';
import SatisfyingButton from './SatisfyingButton';
import FeedbackButton from './FeedbackButton';
import { AnimatePresence, motion } from 'framer-motion';

const GASection = () => {
  const [searchParams] = useSearchParams();
  const feedback = searchParams.get('newsEvaluation');

  const renderFeedback = () => {
    switch (feedback) {
      case 'satisfying':
        return <SatisfyingText />;
      case 'disappointing':
        return <DisappointingText />;
      case 'null':
        return <InitailFeedback />;
      default:
        return <InitailFeedback />;
    }
  };

  return (
    <div className="flex min-h-[60px] flex-col items-center gap-[12px] overflow-hidden text-gr-700 Body5M14">
      <AnimatePresence mode="wait">
        <motion.div
          key={feedback}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="flex w-full justify-center"
        >
          {renderFeedback()}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default GASection;

const InitailFeedback = () => {
  return (
    <div className="flex flex-col items-center gap-[12px] text-gr-700 Body5M14">
      <p className="text-gr-700 Body5M14">오늘의 뉴스 어땠나요?</p>
      <div className="flex gap-[8px]">
        <SatisfyingButton />
        <DisappointingSheet />
      </div>
    </div>
  );
};

const SatisfyingText = () => {
  return <FeedbackButton>앞으로도 유익한 소식만 알려드릴게요❤️</FeedbackButton>;
};

const DisappointingText = () => {
  return <FeedbackButton>다음 뉴스에 잘 반영할게요 🔥</FeedbackButton>;
};
